
<template>
<div class="search-wrap">
    <aside class='search-btn'>
        <ButtonGroup>
            <Button size='large' v-for="(item,index) in btnsearch" :key="index" :type="formData.status===item.value?'primary':'default'" @click="handleBtn('status',item.value)">{{item.label}}</Button>
        </ButtonGroup>
    </aside> 
    <article class="search-main clearfix">
        <div class="pull-left">
            <Button type="primary" @click="handleModal('add')" icon="md-add">{{$t('erp.product.new_add',{defaultValue:'添加'})}}</Button>
            <Dropdown  placement="bottom-start">
                <Button>
                    {{$t('global.common.operates',{defaultValue:'更多操作'})}}&nbsp;<Icon type="md-arrow-dropdown" />
                </Button>
                <DropdownMenu slot="list">
                    <DropdownItem class="splitline" @click.native="handleModal('active')">{{$t('fbb.accountmanage.muti_active',{defaultValue:'批量激活'})}}</DropdownItem>
                    <DropdownItem class="splitline" @click.native="handleModal('init')">{{$t('erp.virtualstore.batchinittalization',{defaultValue:'批量初始化'})}}</DropdownItem>
                    <DropdownItem class="splitline" @click.native="handleModal('cancel')">{{$t('fbb.alloment.muti_cancel',{defaultValue:'批量取消'})}}</DropdownItem>
                    <DropdownItem class="splitline" @click.native="handleModal('delete')">{{$t('erp.virtualstore.batch_delete_virtual_store', { defaultValue: '批量删除虚拟仓' })}}</DropdownItem>
                    <DropdownItem @click.native="handleModal('upload')">{{$t('erp.virtualstore.batch_add_warehouse',{defaultValue:'批量新增仓库'})}}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <Dropdown  placement="bottom-start">
                <Button type="success">
                    {{$t('global.common.export',{defaultValue:'导出'})}}&nbsp;<Icon type="md-arrow-dropdown" />
                </Button>
                <DropdownMenu slot="list">
                    <DropdownItem class="splitline" @click.native="handleModal('exportQuery')">{{$t('global.common.condition_export', { defaultValue: '查询条件导出' })}}</DropdownItem>
                    <DropdownItem class="splitline" @click.native="handleModal('exportChannel')">{{$t('erp.virtualstore.export_query_channel', { defaultValue: '查询条件导出渠道' })}}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>

        <div class="pull-right">
            <Form :label-width="60" inline>
                 <FormItem :label="$t('global.common.name',{defaultValue:'名称'})">
                    <Input clearable v-model.trim="formData.name" :placeholder="$t('global.common.name',{defaultValue:'名称'})"/>
                </FormItem>
                <FormItem label='ERPSKU'>
                    <Input clearable v-model.trim="formData.erpSku" placeholder="ERPSKU"/>
                </FormItem>
                <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                    <Select clearable v-model="formData.lineId" filterable>
                        <Option v-for="item in getNewDifferentAllProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label-width="1">
                    <Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
                    <Button @click="reset" icon='md-refresh'>{{$t('erp.disturibution.reset_order',{defaultValue:'重置'})}}</Button>
                </FormItem>
            </Form>
        </div>
    </article>
</div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import { HttpProductList } from '@/service/boss/allot'
export default {
    data() {
        return {
            formData: {
                name: '',
                erpSku: '',
                lineId: '',
                status: 1,
                ...this.$route.query
            },
            
        };
    },
    computed: {
        // ...mapState('boss',['products'])
        ...mapGetters('diction',['getNewDifferentAllProductList']),
        btnsearch(){
            return [{
                value: 1,
                label: this.$t('erp.channel.active',{defaultValue:'激活'})
            }, {
                value: 0,
                label: this.$t('fbb.alloment.draft',{defaultValue:'草稿'})
            }, {
                value: 2,
                label: this.$t('global.common.operation_cancel',{defaultValue:'取消'})
            },]
        },
        // productTarget() {
        //     return this.getNewDifferentAllProductList.map((item) => {
        //         const bool= item.attach.flag === 3;
        //         return {
        //             label: bool?`${item.label}<span class='color-error'>(已关闭)</span>`:`${item.label}`,
        //             value: item.value,
        //         }
        //     }) 
        // },
    },
    mounted() {
        this.update();
    },
    methods: {
        handleBtn(key, val){
            this.$set(this.formData, key, val); 
            this.update();
        },
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        update() {
            this.$emit('on-update', {
                name: this.formData.name,
                erpSku: this.formData.erpSku,
                lineId: this.formData.lineId,
                status: this.formData.status,
                page: 1
            });
        },
        reset() {
            this.formData = {
                name: '',
                erpSku: '',
                lineId: '',
                status: 1,
            };
            this.$emit('on-update', {
                name: this.formData.name,
                erpSku: this.formData.erpSku,
                lineId: this.formData.lineId,
                status:1,
                page: 1,
            });
        },

    },
};
</script>
